// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"b59506a0","245":"5898afac","419":"62b49523","445":"8a5f2684","648":"d6c54039","854":"e13b4b53"}[chunkId] + ".chunk.css";
};